webpackJsonp([118279676356520],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { Grid, Row, Col } from 'react-flexbox-grid';
	
	var pageTitle = "Pack e-commerce";
	var pageContent = ["Contenu de la prestation pour la création d'un site e-commerce", "avec Prestashop ou Wordpress Woocommerce"];
	
	var Generic = function Generic(props) {
		return _react2.default.createElement(
			'div',
			{ style: props.transition && props.transition.style },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Web2alpes - ',
					pageTitle
				),
				_react2.default.createElement('meta', { name: 'description', content: 'Actions r\xE9alis\xE9es pour la cr\xE9ation d\'un site e-commerce Prestashop ou Wordpress Woocommerce' }),
				_react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' })
			),
			_react2.default.createElement(_BannerLanding2.default, { title: pageTitle, content: pageContent, particles: 'cms', color: 'style-logo-lg' }),
			_react2.default.createElement(
				'div',
				{ id: 'main', className: 'alt' },
				_react2.default.createElement(
					'section',
					{ id: 'support', className: 'tiles' },
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Installation'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Mise en place d\u2019une boutique utilisant les CMS PrestaShop (1.7) ou Wordpress Woocommerce (4.9),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Recherche de l\'h\xE9bergeur et du registrar le plus adapt\xE9 aux besoins,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Inscription, activation de l\u2019h\xE9bergement et du nom de domaine, installation site pilote vers version production,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Optimisation du syst\xE8me de cache et minification du contenu de la boutique afin d\'am\xE9liorer grandement les performances,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un certificat HTTPS pour s\xE9curiser le site Internet,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Configuration et s\xE9curisation du backoffice pour la gestion de la boutique PrestaShop / Wordpress (catalogue produits, commandes, publications,\u2026),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Mise en place de la sauvegarde de la e-boutique,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Possibilit\xE9 d\'installation et de configuration de la station de travail et imprimante pour la gestion du site e-commerce.'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Accompagnement'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Mise en place des pages : accueil, mentions l\xE9gales, conditions g\xE9n\xE9rales de vente, modes de paiements, modes de livraisons, conditions de retours, formulaire de contact et \xE0 propos,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Cr\xE9ation des diff\xE9rents comptes utilisateurs pour l\'exploitation de la boutique,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Cr\xE9ation et configuration des comptes prestashop, woocommerce, paypal, google, envoimoinscher,'
								),
								_react2.default.createElement(
									'li',
									null,
									'R\xE9daction documentation (informations compl\xE8tes site, comptes, h\xE9bergement, processus gestion de commandes),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Formation \xE0 distance ou sur site \xE0 la gestion des commandes, ajout et modification de produits.'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Referencement'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Structure en silos th\xE9matiques pour am\xE9liorer le maillage interne et donc la pertinence pour le r\xE9f\xE9rencement naturel (Google donne beaucoup d\u2019int\xE9r\xEAt \xE0 cette structure),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Statistiques en temps r\xE9el de la boutique (visiteurs en ligne, paniers en cours, fr\xE9quentation, produits, commandes, sites affluents, mots clefs,\u2026),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un module SEO pour l\u2019optimisation du r\xE9f\xE9rencement naturel pour Prestashop ou Wordpress,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Mise en place de Google Analytics pour suivre votre r\xE9f\xE9rencement,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration du fichier sitemap XML pour faciliter l\u2019indexation des moteurs de recherches,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration du plan du site pour limiter les niveaux de profondeur des pages,'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Configuration'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Une seule langue configur\xE9e pour le site e-commerce,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Personnalisation du th\xE8me en fonction de votre identit\xE9 visuelle et de vos attentes,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de votre logo \xE0 la e-boutique,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de vos diff\xE9rents visuels en page d\u2019accueil,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de fonctionnalit\xE9s de partages sur les fiches produits\xA0: Facebook, Google+...,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un formulaire de retour et de la fonctionnalit\xE9 d\u2019envoi des conditions g\xE9n\xE9rales de vente en accord avec la loi Hamon,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un bandeau d\u2019information sur l\u2019utilisation des cookies,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Importations des premiers produit jusqu\'\xE0 l\u2019ensemble des produits,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Configuration de syst\xE8mes de paiements par d\xE9faut (ch\xE8que et virement bancaire, Paypal),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration du module EnvoiMoinsCher pour prestashop (pour la France uniquement, qui comprend les transporteurs : Colissimo, Chronopost, Colis Priv\xE9, Mondial Relay, Relais Colis, DHL, Fedex, TNT, UPS...) et de l\'extension Woocommerce pour Wordpress.'
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pack-e-commerce-js-77ac8fbe136b12967642.js